// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/royalty-banner.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 480px) {
  .landing-wrapper {
    margin-top: 220px;
  }
  .login-title {
    font-size: 30px;
    font-weight: 500;
    font-family: ag;
    color: #00e1ff !important;
    text-align: center;
    padding-bottom: 30px;
  }
  .custom-nav-btn {
    color: var(--text-white) !important;
    padding: 10px 22px;
    border-radius: 100px;
    text-decoration: none;
    transition: all 0.5s;
    font-weight: 600;
    font-size: 15px;
    text-align: center;
    cursor: pointer;
    font-family: Ubuntu;
  }
  .home-container {
    margin-top: 100px;
  }
  .sm-width {
    width: 100%;
  }
  .custom-nav-btn-login {
    color: var(--text-white) !important;
    padding: 10px 22px;
    border-radius: 100px;
    text-decoration: none;
    transition: all 0.5s;
    font-weight: 600;
    font-size: 15px;
    text-align: center;
    cursor: pointer;
    font-family: Ubuntu;
  }
  .footer-des {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
  .plus-sign {
    position: absolute;
    top: 4px;
    left: 8px;
  }
  .home-center {
    width: 100%;
    background-size: cover;
    height: 400px;
    background-position: center;
  }
  .top-padding {
    padding-top: 0px;
  }
  .bottom-padding {
    padding-bottom: 0px !important;
  }
  .preview-top {
    position: absolute;
    top: 164px !important;
    left: 129px !important;
  }
  .preview-top p {
    font-size: 10px;
    font-family: open-sans;
    display: none;
  }
  .join-btn {
    margin-top: 50px;
  }
  .exclusive {
    position: absolute;
    width: 90px !important;
    top: 18px;
    right: 40px;
    z-index: 1000;
  }
  .only {
    position: absolute;
    width: 82px !important;
    right: 7px !important;
    top: 63px !important;
  }
  .main-counter {
    max-width: 696px;
    width: 100%;
    padding: 45px 0px;
    background-color: rgba(255, 255, 255, 0.09);
    border-radius: 8px;
  }
  .email-input {
    width: 100%;
    font-size: 26px;
    background: none;
    font-family: Ubuntu;
    color: white;
    padding: 4px 16px;
  }
  .info-target {
    z-index: 4;
    padding: 10px !important;
  }
  .main-box,
  .main-box-lg {
    padding: 20px;
    margin: 20px 0;
    display: flex;
    justify-content: space-around;
    align-items: baseline;
    flex-direction: column;
  }
  .info-price-value-img {
    width: 155px !important;
  }
  .custom-btn {
    width: 100%;
  }
  .title h2 {
    font-weight: 500;
    font-size: 23px;
    letter-spacing: 2px;
  }
  .title h1 {
    font-size: 31px;
    line-height: 45px;
  }
  .download-btn {
    max-width: 130px;
  }
  .top-back {
    position: absolute;
    top: -132px;
    left: -277px;
  }
  .middle-back {
    position: absolute;
    width: 561px;
    top: -101px;
    right: -576px;
    rotate: 193deg;
  }
  .bottom-back {
    position: absolute;
    width: 561px;
    top: -133px;
    left: -51px;
  }
  .home-title h1 {
    font-size: 25px;
    line-height: 15px;
  }
  .login-button-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    align-items: center;
  }
  .login-panel {
    padding-bottom: 70px;
    padding-top: 70px;
    margin-top: 130px !important;
    margin-bottom: 30px;
  }
  .home-title1 {
    font-size: 20px !important;
  }
}
@media (max-width: 767px) and (min-width: 480px) {
  .login-title {
    font-size: 30px;
    font-weight: 500;
    font-family: ag;
    color: #00e1ff !important;
    text-align: center;
    padding-bottom: 30px;
  }
  .home-container {
    margin-top: 160px;
  }
  .custom-nav-btn {
    color: var(--text-white) !important;
    padding: 10px 22px;
    border-radius: 100px;
    text-decoration: none;
    transition: all 0.5s;
    font-weight: 600;
    font-size: 17px;
    text-align: center;
    cursor: pointer;
    font-family: Ubuntu;
  }
  .custom-nav-btn-login {
    color: var(--text-white) !important;
    padding: 10px 22px;
    border-radius: 100px;
    text-decoration: none;
    transition: all 0.5s;
    font-weight: 600;
    font-size: 17px;
    text-align: center;
    cursor: pointer;
    font-family: Ubuntu;
    margin-bottom: 10px;
  }
  .home-title1 {
    font-size: 20px !important;
  }
  .plus-sign {
    position: absolute;
    top: 4px;
    left: 8px;
  }
  .preview-top {
    position: absolute;
    top: 198px;
    left: 124px;
  }
  .profile-banner {
    width: 100%;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    height: 78px;
    background-position: center;
  }
  .main-counter {
    max-width: 696px;
    width: 100%;
    padding: 45px 0px;
    background-color: rgba(255, 255, 255, 0.09);
    border-radius: 8px;
  }
  .email-input {
    width: 100%;
    font-size: 16px;
    background: none;
    font-family: Ubuntu;
    color: white;
    padding: 4px 16px;
  }
  .title h1 {
    font-size: 31px;
    line-height: 45px;
  }
  .download-btn {
    max-width: 150px;
  }
  .info-price-value-img {
    width: 225px;
  }
  .band {
    width: 700px !important;
    margin-bottom: 100px;
  }
  .profile-band {
    width: 700px !important;
    margin-top: 50px;
  }
  .title h2 {
    font-weight: 500;
    font-size: 23px;
    letter-spacing: 2px;
  }
  .howwork {
    padding: 0px;
  }
  .logo {
    width: 200px;
  }
  .how1 {
    padding-bottom: 1px;
    height: 100%;
  }
  .how2 {
    padding-bottom: 1px;
    height: 100%;
  }
  .how3 {
    padding-bottom: 1px;
    height: 100%;
  }
  .heythere {
    display: none;
  }
  .nav-item {
    padding: 10px 0;
  }
  .navbar-nav {
    align-items: unset !important;
  }
  .nav-custom {
    padding: 0;
    height: auto;
  }
  .stick-icon,
  .stick-icon-right {
    display: none;
  }
  .order-xs-2 {
    order: 2;
  }
  .order-xs-1 {
    order: 1;
  }
  .section-padding {
    padding: 3rem 0;
  }
  .main-section {
    padding: 50px 0;
  }
  .section-img,
  .main-img img {
    width: 200px;
  }
  .main-title p {
    font-size: 10px;
  }
  .custom-tp,
  .custom-btn {
    padding: 10px 12px;
  }
  .social-btn img {
    width: 40px;
    height: 40px;
  }
  .stars {
    display: none;
  }
  .info-box-details h3 {
    font-size: 30px;
  }
  .lg-title {
    font-size: 25px;
    line-height: 30px;
  }
  .sub-title {
    font-size: 18px;
  }
  .img-grp img {
    width: 135px;
  }
  .subscribe input::placeholder {
    font-size: 12px;
  }
  .submit-ab {
    width: 35%;
    padding: 14px 10px;
    font-size: 12px;
  }
  .social-btn ul li {
    margin-bottom: 10px;
  }
  .footer-bottom-child {
    text-align: center;
    flex-direction: column;
  }
  .roadmap-sm-hide {
    display: none;
  }
  .team {
    margin-bottom: 50px;
  }
  .roadmap-meta .roadmap-center,
  .roadmap-meta .roadmap-data {
    width: auto;
  }
  .roadmap-box {
    background-position: 100% 100%;
    background-size: 40%;
    clip-path: polygon(88% 0, 100% 9%, 100% 100%, 0 100%, 0 0);
  }
  .top-back {
    position: absolute;
    width: 1072px !important;
    top: -132px;
    left: -277px;
  }
  .middle-back {
    position: absolute;
    width: 1043px;
    top: -101px;
    right: -576px;
    rotate: 193deg;
  }
  .bottom-back {
    position: absolute;
    width: 1442px;
    top: 109px;
    left: -282px;
  }
  .preview {
    padding-top: 80px;
  }
  .preview p {
    font-family: Ubuntu;
  }
  .preview h2 {
    font-family: orbitron-small;
    font-size: 20px;
  }
  .only {
    position: absolute;
    width: 65px;
    right: 7px;
    top: 84px;
  }
  .login-button-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    align-items: center;
  }
  *::-webkit-scrollbar {
    width: 16px;
  }
  *::-webkit-scrollbar-track {
    background: #28263d;
  }
  *::-webkit-scrollbar-thumb {
    background-color: #4b495c;
    border-radius: 2px;
    border: 3px solid #28263d;
  }
}
@media (min-width: 768px) {
  .home-container {
    margin-top: 260px;
  }
  .roadmap-list {
    display: none;
  }
  .sub-title {
    font-size: 22px;
  }
  .custom-nav-btn {
    background: linear-gradient(90deg, rgb(2, 77, 119) 0%, rgb(50, 181, 207) 51%, rgb(14, 193, 239) 100%, rgb(5, 157, 248) 100%);
    color: var(--text-white) !important;
    padding: 11px 22px;
    margin-left: 27px;
    border-radius: 100px;
    text-decoration: none;
    transition: all 0.5s;
    font-weight: 600;
    font-size: 18px;
    text-align: center;
    cursor: pointer;
    font-family: Ubuntu;
  }
  .custom-nav-btn-login {
    color: var(--text-white) !important;
    padding: 11px 22px;
    margin-left: 27px;
    border-radius: 100px;
    text-decoration: none;
    transition: all 0.5s;
    font-weight: 600;
    font-size: 18px;
    text-align: center;
    cursor: pointer;
    font-family: Ubuntu;
  }
  .preview-top {
    position: absolute;
    top: 204px;
    left: 127px;
  }
  .login-button-container {
    display: flex;
    justify-content: space-around;
    width: 100%;
    align-items: center;
  }
  /* ===== Scrollbar CSS ===== */
  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: #4b495c #28263d;
  }
  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 16px;
  }
  *::-webkit-scrollbar-track {
    background: #28263d;
  }
  *::-webkit-scrollbar-thumb {
    background-color: #4b495c;
    border-radius: 2px;
    border: 3px solid #28263d;
  }
}
@media (max-width: 991px) and (min-width: 768px) {
  .home-container {
    margin-top: 260px;
  }
  .top-back {
    position: absolute;
    width: 878px !important;
    top: -99px;
    left: -136px;
  }
  .info-price-value-img {
    width: 295px;
  }
  .how-padding {
    padding: 20px !important;
  }
  .title h1 {
    font-size: 38px;
    line-height: 55px;
  }
  .sub-title {
    font-size: 22px;
  }
  .home-title h1 {
    font-size: 28px;
    font-weight: 500;
    line-height: 25px;
  }
  .download-btn {
    max-width: 200px;
  }
  .heythere {
    display: none;
  }
  .title h2 {
    font-size: 30px;
  }
  .order-xs-2 {
    order: 2;
  }
  .order-xs-1 {
    order: 1;
  }
  .stick-icon,
  .stick-icon-right {
    opacity: 0.5;
    top: 0;
  }
  .main-section {
    padding: 50px 0;
  }
  .stars img:nth-child(1) {
    position: absolute;
    right: 30px;
  }
  .stars img:nth-child(2) {
    right: 0;
  }
  .team {
    margin-bottom: 50px;
  }
  .middle-back {
    position: absolute;
    width: 1350px;
    top: -101px;
    right: -576px;
    rotate: 193deg;
  }
  .bottom-back {
    position: absolute;
    width: 1350px;
    top: -322px;
    left: -138px;
  }
  .preview {
    padding-top: 80px;
    padding-left: 50px;
  }
  .only {
    position: absolute;
    width: 163px;
    right: 22px;
    top: 71px;
  }
  .preview-top {
    position: absolute;
    top: 206px;
    left: 239px;
  }
  .login-button-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
  .login-bg {
    height: calc(100vh - 100px);
  }
  /* ===== Scrollbar CSS ===== */
  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: #4b495c #28263d;
  }
  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 16px;
  }
  *::-webkit-scrollbar-track {
    background: #28263d;
  }
  *::-webkit-scrollbar-thumb {
    background-color: #4b495c;
    border-radius: 2px;
    border: 3px solid #28263d;
  }
}
@media (max-width: 1200px) and (min-width: 991px) {
  .login-panel {
    padding-bottom: 70px;
    padding-top: 70px;
    margin-top: 130px !important;
  }
  .home-container {
    margin-top: 260px;
  }
  /* ===== Scrollbar CSS ===== */
  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: #4b495c #28263d;
  }
  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 16px;
  }
  *::-webkit-scrollbar-track {
    background: #28263d;
  }
  *::-webkit-scrollbar-thumb {
    background-color: #4b495c;
    border-radius: 2px;
    border: 3px solid #28263d;
  }
  .top-back {
    position: absolute;
    width: 1190px !important;
    top: -191px;
    left: -170px;
  }
  .pl-10 {
    padding-left: 46px;
  }
  .sub-title {
    font-size: 22px;
  }
  .title h1 {
    font-size: 35px;
    line-height: 53px;
  }
  .home-title h1 {
    font-size: 28px;
    font-weight: 500;
    line-height: 25px;
  }
  .title h2 {
    font-size: 30px;
  }
  .logo {
    width: 200px;
  }
  .nav-item {
    padding: 0 10px;
  }
  .custom-tp,
  .custom-btn {
    font-size: 19px;
    padding: 10px 12px;
  }
  .info-box-details h3 {
    font-size: 30px;
  }
  .social-btn ul li {
    margin-bottom: 10px;
  }
  .subscribe input::placeholder {
    font-size: 15px;
  }
  .submit-ab {
    width: 35%;
    padding: 14px 10px;
    font-size: 15px;
  }
  .footer-menu li {
    font-size: 12px;
  }
  .lg-title {
    font-size: 40px;
  }
  .social-btn img {
    width: 40px;
    height: 40px;
  }
  .team {
    margin-bottom: 50px;
  }
  .how-padding {
    padding: 15px !important;
  }
  .middle-back {
    position: absolute;
    width: 1362px;
    top: -101px;
    right: -576px;
    rotate: 193deg;
  }
  .bottom-back {
    position: absolute;
    width: 1403px;
    top: 50px;
    left: -138px;
  }
  .preview {
    padding-top: 85px;
    padding-left: 50px;
  }
  .info-price-value-img {
    width: 175px;
  }
  .only {
    position: absolute;
    width: 95px;
    right: 14px;
    top: 82px;
  }
  .preview-top {
    position: absolute;
    top: 161px;
    left: 121px;
  }
  .preview-top p {
    font-size: 10px;
    font-family: open-sans;
    display: none;
  }
  .login-button-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
  .login-bg {
    height: calc(100vh - 100px);
  }
}
@media (max-width: 1440px) and (min-width: 1200px) {
  .login-panel {
    padding-bottom: 70px;
    padding-top: 70px;
    margin-top: 130px !important;
  }
  /* ===== Scrollbar CSS ===== */
  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: #4b495c #28263d;
  }
  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 16px;
  }
  *::-webkit-scrollbar-track {
    background: #28263d;
  }
  *::-webkit-scrollbar-thumb {
    background-color: #4b495c;
    border-radius: 2px;
    border: 3px solid #28263d;
  }
  .login-button-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
  .top-back {
    position: absolute;
    width: 1327px;
    top: -204px;
    left: -171px;
  }
  .social-btn ul li {
    margin-bottom: 10px;
  }
  .how-padding {
    padding: 15px !important;
  }
  .sub-title {
    font-size: 25px;
  }
  .title h1 {
    font-size: 45px;
  }
  .home-title h1 {
    font-size: 31px;
    font-weight: 500;
    line-height: 45px;
  }
  .title h2 {
    font-size: 35px;
  }
  .pl-10 {
    padding-left: 46px;
  }
  .faq-container {
    padding-left: 130px !important;
    padding-right: 130px !important;
  }
  .middle-back {
    position: absolute;
    width: 1719px !important;
    top: -101px;
    right: -576px;
    rotate: 193deg;
  }
  .bottom-back {
    position: absolute;
    width: 1717px !important;
    top: -39px;
    left: -138px;
  }
  .preview {
    padding-top: 100px;
    padding-left: 150px;
  }
  .info-price-value-img {
    width: 240px;
  }
  .only {
    position: absolute;
    width: 120px;
    right: 14px;
    top: 79px;
  }
  .preview-top {
    position: absolute;
    top: 200px;
    left: 118px;
  }
  .login-bg {
    height: calc(100vh - 100px);
  }
  .home-title1 {
    font-size: 30px !important;
  }
}
@media (min-width: 1440px) {
  /* ===== Scrollbar CSS ===== */
  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: #4b495c #28263d;
  }
  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 16px;
  }
  *::-webkit-scrollbar-track {
    background: #28263d;
  }
  *::-webkit-scrollbar-thumb {
    background-color: #4b495c;
    border-radius: 2px;
    border: 3px solid #28263d;
  }
  .top-back {
    position: absolute;
    width: 1399px !important;
    top: -242px;
    left: 150px;
  }
  .pl-10 {
    padding-left: 46px;
  }
  .how-padding {
    padding: 40px !important;
  }
  .faq-container {
    padding-left: 220px !important;
    padding-right: 220px !important;
  }
  .middle-back {
    position: absolute;
    width: 2236px !important;
    top: -101px;
    right: -576px;
    rotate: 193deg;
  }
  .bottom-back {
    position: absolute;
    width: 1952px !important;
    top: -240px;
    left: 100px;
  }
  .preview-top {
    position: absolute;
    top: 210px;
    left: 155px;
  }
  .preview {
    padding-top: 110px;
    padding-left: 150px;
  }
  .info-price-value-img {
    width: 245px;
  }
  .login-button-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
  .login-bg {
    height: calc(100vh - 100px);
  }
  .home-container {
    margin-top: 200px;
  }
  .home-title1 {
    font-size: 30px !important;
  }
  .login-panel {
    padding-bottom: 70px;
    padding-top: 70px;
    margin-top: 130px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/responsive.scss"],"names":[],"mappings":"AAAA;EAEE;IACE,iBAAA;EAAF;EAGA;IACE,eAAA;IACA,gBAAA;IACA,eAAA;IACA,yBAAA;IACA,kBAAA;IACA,oBAAA;EADF;EAIA;IACE,mCAAA;IACA,kBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;EAFF;EAKA;IACE,iBAAA;EAHF;EAMA;IACE,WAAA;EAJF;EAOA;IACE,mCAAA;IACA,kBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;EALF;EAQA;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,uBAAA;EANF;EASA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;EAPF;EAUA;IACE,WAAA;IACA,sBAAA;IACA,aAAA;IACA,2BAAA;EARF;EAWA;IACE,gBAAA;EATF;EAYA;IACE,8BAAA;EAVF;EAaA;IACE,kBAAA;IACA,qBAAA;IACA,sBAAA;EAXF;EAcA;IACE,eAAA;IACA,sBAAA;IACA,aAAA;EAZF;EAeA;IACE,gBAAA;EAbF;EAgBA;IACE,kBAAA;IACA,sBAAA;IACA,SAAA;IACA,WAAA;IACA,aAAA;EAdF;EAiBA;IACE,kBAAA;IACA,sBAAA;IACA,qBAAA;IACA,oBAAA;EAfF;EAkBA;IACE,gBAAA;IACA,WAAA;IACA,iBAAA;IACA,2CAAA;IACA,kBAAA;EAhBF;EAmBA;IACE,WAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;IACA,YAAA;IACA,iBAAA;EAjBF;EAoBA;IACE,UAAA;IACA,wBAAA;EAlBF;EAqBA;;IAEE,aAAA;IACA,cAAA;IACA,aAAA;IACA,6BAAA;IACA,qBAAA;IACA,sBAAA;EAnBF;EAsBA;IACE,uBAAA;EApBF;EAuBA;IACE,WAAA;EArBF;EAwBA;IACE,gBAAA;IACA,eAAA;IACA,mBAAA;EAtBF;EAyBA;IACE,eAAA;IACA,iBAAA;EAvBF;EA0BA;IACE,gBAAA;EAxBF;EA2BA;IACE,kBAAA;IACA,WAAA;IACA,YAAA;EAzBF;EA6BA;IACE,kBAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;IACA,cAAA;EA3BF;EA8BA;IACE,kBAAA;IACA,YAAA;IACA,WAAA;IACA,WAAA;EA5BF;EA+BA;IACE,eAAA;IACA,iBAAA;EA7BF;EAgCA;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,mBAAA;EA9BF;EAiCA;IACE,oBAAA;IACA,iBAAA;IACA,4BAAA;IACA,mBAAA;EA/BF;EAkCA;IACE,0BAAA;EAhCF;AACF;AAmCA;EACE;IACE,eAAA;IACA,gBAAA;IACA,eAAA;IACA,yBAAA;IACA,kBAAA;IACA,oBAAA;EAjCF;EAoCA;IACE,iBAAA;EAlCF;EAqCA;IACE,mCAAA;IACA,kBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;EAnCF;EAsCA;IACE,mCAAA;IACA,kBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;IACA,mBAAA;EApCF;EAwCA;IACE,0BAAA;EAtCF;EAyCA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;EAvCF;EA0CA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;EAxCF;EA2CA;IACE,WAAA;IACA,mDAAA;IACA,sBAAA;IACA,YAAA;IACA,2BAAA;EAzCF;EA4CA;IACE,gBAAA;IACA,WAAA;IACA,iBAAA;IACA,2CAAA;IACA,kBAAA;EA1CF;EA6CA;IACE,WAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;IACA,YAAA;IACA,iBAAA;EA3CF;EA8CA;IACE,eAAA;IACA,iBAAA;EA5CF;EA+CA;IACE,gBAAA;EA7CF;EAgDA;IACE,YAAA;EA9CF;EAkDA;IACE,uBAAA;IACA,oBAAA;EAhDF;EAmDA;IACE,uBAAA;IACA,gBAAA;EAjDF;EAoDA;IACE,gBAAA;IACA,eAAA;IACA,mBAAA;EAlDF;EAqDA;IACE,YAAA;EAnDF;EAsDA;IAEE,YAAA;EArDF;EAyDA;IACE,mBAAA;IACA,YAAA;EAvDF;EA0DA;IACE,mBAAA;IACA,YAAA;EAxDF;EA2DA;IACE,mBAAA;IACA,YAAA;EAzDF;EA4DA;IACE,aAAA;EA1DF;EAgEA;IAEE,eAAA;EA/DF;EAmEA;IAEE,6BAAA;EAlEF;EAsEA;IAEE,UAAA;IACA,YAAA;EArEF;EAyEA;;IAGE,aAAA;EAxEF;EA4EA;IAEE,QAAA;EA3EF;EAgFA;IAEE,QAAA;EA/EF;EAoFA;IACE,eAAA;EAlFF;EAsFA;IAEE,eAAA;EArFF;EAyFA;;IAGE,YAAA;EAxFF;EA4FA;IAEE,eAAA;EA3FF;EAkGA;;IAEE,kBAAA;EAhGF;EAmGA;IACE,WAAA;IACA,YAAA;EAjGF;EAqGA;IAEE,aAAA;EApGF;EAwGA;IAEE,eAAA;EAvGF;EA0GA;IAEE,eAAA;IACA,iBAAA;EAzGF;EA4GA;IACE,eAAA;EA1GF;EA8GA;IACE,YAAA;EA5GF;EAgHA;IAGE,eAAA;EAhHF;EAoHA;IAEE,UAAA;IAEA,kBAAA;IACA,eAAA;EApHF;EAyHA;IAEE,mBAAA;EAxHF;EA4HA;IAEE,kBAAA;IACA,sBAAA;EA3HF;EAgIA;IAEE,aAAA;EA/HF;EAmIA;IAEE,mBAAA;EAlIF;EAsIA;;IAGE,WAAA;EArIF;EAyIA;IAEE,8BAAA;IACA,oBAAA;IAEA,0DAAA;EAxIF;EA4IA;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,YAAA;EA1IF;EA6IA;IACE,kBAAA;IACA,aAAA;IACA,WAAA;IACA,aAAA;IACA,cAAA;EA3IF;EA8IA;IACE,kBAAA;IACA,aAAA;IACA,UAAA;IACA,YAAA;EA5IF;EA+IA;IACE,iBAAA;EA7IF;EAgJA;IACE,mBAAA;EA9IF;EAiJA;IACE,2BAAA;IACA,eAAA;EA/IF;EAkJA;IACE,kBAAA;IACA,WAAA;IACA,UAAA;IACA,SAAA;EAhJF;EAoJA;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,mBAAA;EAlJF;EAqJA;IACE,WAAA;EAnJF;EAsJA;IACE,mBAAA;EApJF;EAuJA;IACE,yBAAA;IACA,kBAAA;IACA,yBAAA;EArJF;AACF;AAwJA;EAEE;IACE,iBAAA;EAvJF;EA0JA;IACE,aAAA;EAxJF;EA2JA;IACE,eAAA;EAzJF;EA4JA;IACE,4HAAA;IACA,mCAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;EA1JF;EA6JA;IACE,mCAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;EA3JF;EA8JA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;EA5JF;EA+JA;IACE,aAAA;IACA,6BAAA;IACA,WAAA;IACA,mBAAA;EA7JF;EAgKA,8BAAA;EACA,YAAA;EACA;IACE,qBAAA;IACA,gCAAA;EA9JF;EAiKA,6BAAA;EACA;IACE,WAAA;EA/JF;EAkKA;IACE,mBAAA;EAhKF;EAmKA;IACE,yBAAA;IACA,kBAAA;IACA,yBAAA;EAjKF;AACF;AAqKA;EAEE;IACE,iBAAA;EApKF;EAuKA;IACE,kBAAA;IACA,uBAAA;IACA,UAAA;IACA,YAAA;EArKF;EAwKA;IACE,YAAA;EAtKF;EAyKA;IACE,wBAAA;EAvKF;EA0KA;IACE,eAAA;IACA,iBAAA;EAxKF;EA2KA;IACE,eAAA;EAzKF;EA4KA;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EA1KF;EA6KA;IACE,gBAAA;EA3KF;EA8KA;IACE,aAAA;EA5KF;EA+KA;IACE,eAAA;EA7KF;EAgLA;IAEE,QAAA;EA/KF;EAoLA;IAEE,QAAA;EAnLF;EAuLA;;IAGE,YAAA;IACA,MAAA;EAtLF;EAyLA;IAEE,eAAA;EAxLF;EA6LA;IAEE,kBAAA;IACA,WAAA;EA5LF;EAiMA;IAGE,QAAA;EAjMF;EAqMA;IAEE,mBAAA;EApMF;EAwMA;IACE,kBAAA;IACA,aAAA;IACA,WAAA;IACA,aAAA;IACA,cAAA;EAtMF;EAyMA;IACE,kBAAA;IACA,aAAA;IACA,WAAA;IACA,YAAA;EAvMF;EA0MA;IACE,iBAAA;IACA,kBAAA;EAxMF;EA2MA;IACE,kBAAA;IACA,YAAA;IACA,WAAA;IACA,SAAA;EAzMF;EA4MA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;EA1MF;EA6MA;IACE,aAAA;IACA,8BAAA;IACA,WAAA;IACA,mBAAA;EA3MF;EA8MA;IACE,2BAAA;EA5MF;EA+MA,8BAAA;EACA,YAAA;EACA;IACE,qBAAA;IACA,gCAAA;EA7MF;EAgNA,6BAAA;EACA;IACE,WAAA;EA9MF;EAiNA;IACE,mBAAA;EA/MF;EAkNA;IACE,yBAAA;IACA,kBAAA;IACA,yBAAA;EAhNF;AACF;AAoNA;EAEE;IACE,oBAAA;IACA,iBAAA;IACA,4BAAA;EAnNF;EAsNA;IACE,iBAAA;EApNF;EAuNA,8BAAA;EACA,YAAA;EACA;IACE,qBAAA;IACA,gCAAA;EArNF;EAwNA,6BAAA;EACA;IACE,WAAA;EAtNF;EAyNA;IACE,mBAAA;EAvNF;EA0NA;IACE,yBAAA;IACA,kBAAA;IACA,yBAAA;EAxNF;EA2NA;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,YAAA;EAzNF;EA4NA;IACE,kBAAA;EA1NF;EA6NA;IACE,eAAA;EA3NF;EA8NA;IACE,eAAA;IACA,iBAAA;EA5NF;EA+NA;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EA7NF;EAgOA;IACE,eAAA;EA9NF;EAiOA;IAEE,YAAA;EAhOF;EAoOA;IAEE,eAAA;EAnOF;EAwOA;;IAEE,eAAA;IACA,kBAAA;EAtOF;EA0OA;IAEE,eAAA;EAzOF;EA6OA;IAEE,mBAAA;EA5OF;EAiPA;IAGE,eAAA;EAjPF;EAqPA;IAEE,UAAA;IACA,kBAAA;IACA,eAAA;EApPF;EAwPA;IAEE,eAAA;EAvPF;EA2PA;IAEE,eAAA;EA1PF;EA8PA;IACE,WAAA;IACA,YAAA;EA5PF;EA+PA;IAEE,mBAAA;EA9PF;EAkQA;IACE,wBAAA;EAhQF;EAmQA;IACE,kBAAA;IACA,aAAA;IACA,WAAA;IACA,aAAA;IACA,cAAA;EAjQF;EAoQA;IACE,kBAAA;IACA,aAAA;IACA,SAAA;IACA,YAAA;EAlQF;EAqQA;IACE,iBAAA;IACA,kBAAA;EAnQF;EAsQA;IACE,YAAA;EApQF;EAuQA;IACE,kBAAA;IACA,WAAA;IACA,WAAA;IACA,SAAA;EArQF;EAwQA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;EAtQF;EAyQA;IACE,eAAA;IACA,sBAAA;IACA,aAAA;EAvQF;EA0QA;IACE,aAAA;IACA,8BAAA;IACA,WAAA;IACA,mBAAA;EAxQF;EA2QA;IACE,2BAAA;EAzQF;AACF;AA8QA;EAEE;IACE,oBAAA;IACA,iBAAA;IACA,4BAAA;EA7QF;EAgRA,8BAAA;EACA,YAAA;EACA;IACE,qBAAA;IACA,gCAAA;EA9QF;EAiRA,6BAAA;EACA;IACE,WAAA;EA/QF;EAkRA;IACE,mBAAA;EAhRF;EAmRA;IACE,yBAAA;IACA,kBAAA;IACA,yBAAA;EAjRF;EAoRA;IACE,aAAA;IACA,8BAAA;IACA,WAAA;IACA,mBAAA;EAlRF;EAqRA;IACE,kBAAA;IACA,aAAA;IACA,WAAA;IACA,YAAA;EAnRF;EAsRA;IAEE,mBAAA;EArRF;EAyRA;IACE,wBAAA;EAvRF;EA0RA;IACE,eAAA;EAxRF;EA2RA;IACE,eAAA;EAzRF;EA4RA;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EA1RF;EA6RA;IACE,eAAA;EA3RF;EA8RA;IACE,kBAAA;EA5RF;EA+RA;IACE,8BAAA;IACA,+BAAA;EA7RF;EAgSA;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,aAAA;IACA,cAAA;EA9RF;EAiSA;IACE,kBAAA;IACA,wBAAA;IACA,UAAA;IACA,YAAA;EA/RF;EAkSA;IACE,kBAAA;IACA,mBAAA;EAhSF;EAmSA;IACE,YAAA;EAjSF;EAoSA;IACE,kBAAA;IACA,YAAA;IACA,WAAA;IACA,SAAA;EAlSF;EAqSA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;EAnSF;EAuSA;IACE,2BAAA;EArSF;EAwSA;IACE,0BAAA;EAtSF;AACF;AAySA;EAEE,8BAAA;EACA,YAAA;EACA;IACE,qBAAA;IACA,gCAAA;EAxSF;EA2SA,6BAAA;EACA;IACE,WAAA;EAzSF;EA4SA;IACE,mBAAA;EA1SF;EA6SA;IACE,yBAAA;IACA,kBAAA;IACA,yBAAA;EA3SF;EA8SA;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,WAAA;EA5SF;EA+SA;IACE,kBAAA;EA7SF;EAgTA;IACE,wBAAA;EA9SF;EAiTA;IACE,8BAAA;IACA,+BAAA;EA/SF;EAkTA;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,aAAA;IACA,cAAA;EAhTF;EAmTA;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,WAAA;EAjTF;EAoTA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;EAlTF;EAqTA;IACE,kBAAA;IACA,mBAAA;EAnTF;EAsTA;IACE,YAAA;EApTF;EAuTA;IACE,aAAA;IACA,8BAAA;IACA,WAAA;IACA,mBAAA;EArTF;EAwTA;IACE,2BAAA;EAtTF;EAyTA;IACE,iBAAA;EAvTF;EA0TA;IACE,0BAAA;EAxTF;EA2TA;IACE,oBAAA;IACA,iBAAA;IACA,4BAAA;EAzTF;AACF","sourcesContent":["@media (max-width: 480px) {\r\n\r\n  .landing-wrapper {\r\n    margin-top: 220px;\r\n  }\r\n\r\n  .login-title {\r\n    font-size: 30px;\r\n    font-weight: 500;\r\n    font-family: ag;\r\n    color: #00e1ff !important;\r\n    text-align: center;\r\n    padding-bottom: 30px;\r\n  }\r\n\r\n  .custom-nav-btn {\r\n    color: var(--text-white) !important;\r\n    padding: 10px 22px;\r\n    border-radius: 100px;\r\n    text-decoration: none;\r\n    transition: all 0.5s;\r\n    font-weight: 600;\r\n    font-size: 15px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-family: Ubuntu;\r\n  }\r\n\r\n  .home-container {\r\n    margin-top: 100px;\r\n  }\r\n\r\n  .sm-width {\r\n    width: 100%;\r\n  }\r\n\r\n  .custom-nav-btn-login {\r\n    color: var(--text-white) !important;\r\n    padding: 10px 22px;\r\n    border-radius: 100px;\r\n    text-decoration: none;\r\n    transition: all 0.5s;\r\n    font-weight: 600;\r\n    font-size: 15px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-family: Ubuntu;\r\n  }\r\n\r\n  .footer-des {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .plus-sign {\r\n    position: absolute;\r\n    top: 4px;\r\n    left: 8px;\r\n  }\r\n\r\n  .home-center {\r\n    width: 100%;\r\n    background-size: cover;\r\n    height: 400px;\r\n    background-position: center;\r\n  }\r\n\r\n  .top-padding {\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .bottom-padding {\r\n    padding-bottom: 0px !important;\r\n  }\r\n\r\n  .preview-top {\r\n    position: absolute;\r\n    top: 164px !important;\r\n    left: 129px !important;\r\n  }\r\n\r\n  .preview-top p {\r\n    font-size: 10px;\r\n    font-family: open-sans;\r\n    display: none;\r\n  }\r\n\r\n  .join-btn {\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .exclusive {\r\n    position: absolute;\r\n    width: 90px !important;\r\n    top: 18px;\r\n    right: 40px;\r\n    z-index: 1000;\r\n  }\r\n\r\n  .only {\r\n    position: absolute;\r\n    width: 82px !important;\r\n    right: 7px !important;\r\n    top: 63px !important;\r\n  }\r\n\r\n  .main-counter {\r\n    max-width: 696px;\r\n    width: 100%;\r\n    padding: 45px 0px;\r\n    background-color: rgba(255, 255, 255, 0.09);\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .email-input {\r\n    width: 100%;\r\n    font-size: 26px;\r\n    background: none;\r\n    font-family: Ubuntu;\r\n    color: white;\r\n    padding: 4px 16px;\r\n  }\r\n\r\n  .info-target {\r\n    z-index: 4;\r\n    padding: 10px !important;\r\n  }\r\n\r\n  .main-box,\r\n  .main-box-lg {\r\n    padding: 20px;\r\n    margin: 20px 0;\r\n    display: flex;\r\n    justify-content: space-around;\r\n    align-items: baseline;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .info-price-value-img {\r\n    width: 155px !important;\r\n  }\r\n\r\n  .custom-btn {\r\n    width: 100%;\r\n  }\r\n\r\n  .title h2 {\r\n    font-weight: 500;\r\n    font-size: 23px;\r\n    letter-spacing: 2px;\r\n  }\r\n\r\n  .title h1 {\r\n    font-size: 31px;\r\n    line-height: 45px;\r\n  }\r\n\r\n  .download-btn {\r\n    max-width: 130px;\r\n  }\r\n\r\n  .top-back {\r\n    position: absolute;\r\n    top: -132px;\r\n    left: -277px;\r\n  }\r\n\r\n\r\n  .middle-back {\r\n    position: absolute;\r\n    width: 561px;\r\n    top: -101px;\r\n    right: -576px;\r\n    rotate: 193deg;\r\n  }\r\n\r\n  .bottom-back {\r\n    position: absolute;\r\n    width: 561px;\r\n    top: -133px;\r\n    left: -51px;\r\n  }\r\n\r\n  .home-title h1 {\r\n    font-size: 25px;\r\n    line-height: 15px;\r\n  }\r\n\r\n  .login-button-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .login-panel {\r\n    padding-bottom: 70px;\r\n    padding-top: 70px;\r\n    margin-top: 130px !important;\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n  .home-title1 {\r\n    font-size: 20px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) and (min-width: 480px) {\r\n  .login-title {\r\n    font-size: 30px;\r\n    font-weight: 500;\r\n    font-family: ag;\r\n    color: #00e1ff !important;\r\n    text-align: center;\r\n    padding-bottom: 30px;\r\n  }\r\n\r\n  .home-container {\r\n    margin-top: 160px;\r\n  }\r\n\r\n  .custom-nav-btn {\r\n    color: var(--text-white) !important;\r\n    padding: 10px 22px;\r\n    border-radius: 100px;\r\n    text-decoration: none;\r\n    transition: all 0.5s;\r\n    font-weight: 600;\r\n    font-size: 17px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-family: Ubuntu;\r\n  }\r\n\r\n  .custom-nav-btn-login {\r\n    color: var(--text-white) !important;\r\n    padding: 10px 22px;\r\n    border-radius: 100px;\r\n    text-decoration: none;\r\n    transition: all 0.5s;\r\n    font-weight: 600;\r\n    font-size: 17px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-family: Ubuntu;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n\r\n  .home-title1 {\r\n    font-size: 20px !important;\r\n  }\r\n\r\n  .plus-sign {\r\n    position: absolute;\r\n    top: 4px;\r\n    left: 8px;\r\n  }\r\n\r\n  .preview-top {\r\n    position: absolute;\r\n    top: 198px;\r\n    left: 124px;\r\n  }\r\n\r\n  .profile-banner {\r\n    width: 100%;\r\n    background: url(../images/royalty-banner.svg);\r\n    background-size: cover;\r\n    height: 78px;\r\n    background-position: center;\r\n  }\r\n\r\n  .main-counter {\r\n    max-width: 696px;\r\n    width: 100%;\r\n    padding: 45px 0px;\r\n    background-color: rgba(255, 255, 255, 0.09);\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .email-input {\r\n    width: 100%;\r\n    font-size: 16px;\r\n    background: none;\r\n    font-family: Ubuntu;\r\n    color: white;\r\n    padding: 4px 16px;\r\n  }\r\n\r\n  .title h1 {\r\n    font-size: 31px;\r\n    line-height: 45px;\r\n  }\r\n\r\n  .download-btn {\r\n    max-width: 150px;\r\n  }\r\n\r\n  .info-price-value-img {\r\n    width: 225px;\r\n  }\r\n\r\n\r\n  .band {\r\n    width: 700px !important;\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .profile-band {\r\n    width: 700px !important;\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .title h2 {\r\n    font-weight: 500;\r\n    font-size: 23px;\r\n    letter-spacing: 2px;\r\n  }\r\n\r\n  .howwork {\r\n    padding: 0px;\r\n  }\r\n\r\n  .logo {\r\n\r\n    width: 200px;\r\n\r\n  }\r\n\r\n  .how1 {\r\n    padding-bottom: 1px;\r\n    height: 100%;\r\n  }\r\n\r\n  .how2 {\r\n    padding-bottom: 1px;\r\n    height: 100%;\r\n  }\r\n\r\n  .how3 {\r\n    padding-bottom: 1px;\r\n    height: 100%;\r\n  }\r\n\r\n  .heythere {\r\n    display: none;\r\n  }\r\n\r\n\r\n\r\n\r\n  .nav-item {\r\n\r\n    padding: 10px 0;\r\n\r\n  }\r\n\r\n  .navbar-nav {\r\n\r\n    align-items: unset !important;\r\n\r\n  }\r\n\r\n  .nav-custom {\r\n\r\n    padding: 0;\r\n    height: auto;\r\n\r\n  }\r\n\r\n  .stick-icon,\r\n  .stick-icon-right {\r\n\r\n    display: none;\r\n\r\n  }\r\n\r\n  .order-xs-2 {\r\n\r\n    order: 2;\r\n\r\n  }\r\n\r\n\r\n  .order-xs-1 {\r\n\r\n    order: 1;\r\n\r\n  }\r\n\r\n\r\n  .section-padding {\r\n    padding: 3rem 0;\r\n\r\n  }\r\n\r\n  .main-section {\r\n\r\n    padding: 50px 0;\r\n\r\n  }\r\n\r\n  .section-img,\r\n  .main-img img {\r\n\r\n    width: 200px;\r\n\r\n  }\r\n\r\n  .main-title p {\r\n\r\n    font-size: 10px;\r\n\r\n  }\r\n\r\n\r\n\r\n\r\n  .custom-tp,\r\n  .custom-btn {\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  .social-btn img {\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n\r\n\r\n  .stars {\r\n\r\n    display: none;\r\n\r\n  }\r\n\r\n  .info-box-details h3 {\r\n\r\n    font-size: 30px;\r\n  }\r\n\r\n  .lg-title {\r\n\r\n    font-size: 25px;\r\n    line-height: 30px;\r\n  }\r\n\r\n  .sub-title {\r\n    font-size: 18px;\r\n  }\r\n\r\n\r\n  .img-grp img {\r\n    width: 135px;\r\n  }\r\n\r\n\r\n  .subscribe input::placeholder {\r\n\r\n\r\n    font-size: 12px;\r\n  }\r\n\r\n\r\n  .submit-ab {\r\n\r\n    width: 35%;\r\n\r\n    padding: 14px 10px;\r\n    font-size: 12px;\r\n\r\n  }\r\n\r\n\r\n  .social-btn ul li {\r\n\r\n    margin-bottom: 10px;\r\n\r\n  }\r\n\r\n  .footer-bottom-child {\r\n\r\n    text-align: center;\r\n    flex-direction: column;\r\n\r\n  }\r\n\r\n\r\n  .roadmap-sm-hide {\r\n\r\n    display: none;\r\n\r\n  }\r\n\r\n  .team {\r\n\r\n    margin-bottom: 50px;\r\n\r\n  }\r\n\r\n  .roadmap-meta .roadmap-center,\r\n  .roadmap-meta .roadmap-data {\r\n\r\n    width: auto;\r\n\r\n  }\r\n\r\n  .roadmap-box {\r\n\r\n    background-position: 100% 100%;\r\n    background-size: 40%;\r\n    -webkit-clip-path: polygon(88% 0, 100% 9%, 100% 100%, 0 100%, 0 0);\r\n    clip-path: polygon(88% 0, 100% 9%, 100% 100%, 0 100%, 0 0);\r\n  }\r\n\r\n\r\n  .top-back {\r\n    position: absolute;\r\n    width: 1072px !important;\r\n    top: -132px;\r\n    left: -277px;\r\n  }\r\n\r\n  .middle-back {\r\n    position: absolute;\r\n    width: 1043px;\r\n    top: -101px;\r\n    right: -576px;\r\n    rotate: 193deg;\r\n  }\r\n\r\n  .bottom-back {\r\n    position: absolute;\r\n    width: 1442px;\r\n    top: 109px;\r\n    left: -282px;\r\n  }\r\n\r\n  .preview {\r\n    padding-top: 80px;\r\n  }\r\n\r\n  .preview p {\r\n    font-family: Ubuntu;\r\n  }\r\n\r\n  .preview h2 {\r\n    font-family: orbitron-small;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .only {\r\n    position: absolute;\r\n    width: 65px;\r\n    right: 7px;\r\n    top: 84px;\r\n\r\n  }\r\n\r\n  .login-button-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  *::-webkit-scrollbar {\r\n    width: 16px;\r\n  }\r\n\r\n  *::-webkit-scrollbar-track {\r\n    background: #28263d;\r\n  }\r\n\r\n  *::-webkit-scrollbar-thumb {\r\n    background-color: #4b495c;\r\n    border-radius: 2px;\r\n    border: 3px solid #28263d;\r\n  }\r\n}\r\n\r\n@media (min-width:768px) {\r\n\r\n  .home-container {\r\n    margin-top: 260px;\r\n  }\r\n\r\n  .roadmap-list {\r\n    display: none;\r\n  }\r\n\r\n  .sub-title {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .custom-nav-btn {\r\n    background: linear-gradient(90deg, rgba(2, 77, 119, 1) 0%, rgba(50, 181, 207, 1) 51%, rgba(14, 193, 239, 1) 100%, rgba(5, 157, 248, 1) 100%);\r\n    color: var(--text-white) !important;\r\n    padding: 11px 22px;\r\n    margin-left: 27px;\r\n    border-radius: 100px;\r\n    text-decoration: none;\r\n    transition: all 0.5s;\r\n    font-weight: 600;\r\n    font-size: 18px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-family: Ubuntu;\r\n  }\r\n\r\n  .custom-nav-btn-login {\r\n    color: var(--text-white) !important;\r\n    padding: 11px 22px;\r\n    margin-left: 27px;\r\n    border-radius: 100px;\r\n    text-decoration: none;\r\n    transition: all 0.5s;\r\n    font-weight: 600;\r\n    font-size: 18px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-family: Ubuntu;\r\n  }\r\n\r\n  .preview-top {\r\n    position: absolute;\r\n    top: 204px;\r\n    left: 127px;\r\n  }\r\n\r\n  .login-button-container {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  /* ===== Scrollbar CSS ===== */\r\n  /* Firefox */\r\n  * {\r\n    scrollbar-width: auto;\r\n    scrollbar-color: #4b495c #28263d;\r\n  }\r\n\r\n  /* Chrome, Edge, and Safari */\r\n  *::-webkit-scrollbar {\r\n    width: 16px;\r\n  }\r\n\r\n  *::-webkit-scrollbar-track {\r\n    background: #28263d;\r\n  }\r\n\r\n  *::-webkit-scrollbar-thumb {\r\n    background-color: #4b495c;\r\n    border-radius: 2px;\r\n    border: 3px solid #28263d;\r\n  }\r\n\r\n}\r\n\r\n@media (max-width: 991px) and (min-width: 768px) {\r\n\r\n  .home-container {\r\n    margin-top: 260px;\r\n  }\r\n\r\n  .top-back {\r\n    position: absolute;\r\n    width: 878px !important;\r\n    top: -99px;\r\n    left: -136px;\r\n  }\r\n\r\n  .info-price-value-img {\r\n    width: 295px;\r\n  }\r\n\r\n  .how-padding {\r\n    padding: 20px !important;\r\n  }\r\n\r\n  .title h1 {\r\n    font-size: 38px;\r\n    line-height: 55px;\r\n  }\r\n\r\n  .sub-title {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .home-title h1 {\r\n    font-size: 28px;\r\n    font-weight: 500;\r\n    line-height: 25px;\r\n  }\r\n\r\n  .download-btn {\r\n    max-width: 200px;\r\n  }\r\n\r\n  .heythere {\r\n    display: none;\r\n  }\r\n\r\n  .title h2 {\r\n    font-size: 30px;\r\n  }\r\n\r\n  .order-xs-2 {\r\n\r\n    order: 2;\r\n\r\n  }\r\n\r\n\r\n  .order-xs-1 {\r\n\r\n    order: 1;\r\n\r\n  }\r\n\r\n  .stick-icon,\r\n  .stick-icon-right {\r\n\r\n    opacity: 0.5;\r\n    top: 0;\r\n  }\r\n\r\n  .main-section {\r\n\r\n    padding: 50px 0;\r\n\r\n  }\r\n\r\n\r\n  .stars img:nth-child(1) {\r\n\r\n    position: absolute;\r\n    right: 30px;\r\n\r\n  }\r\n\r\n\r\n  .stars img:nth-child(2) {\r\n\r\n\r\n    right: 0;\r\n\r\n  }\r\n\r\n  .team {\r\n\r\n    margin-bottom: 50px;\r\n\r\n  }\r\n\r\n  .middle-back {\r\n    position: absolute;\r\n    width: 1350px;\r\n    top: -101px;\r\n    right: -576px;\r\n    rotate: 193deg;\r\n  }\r\n\r\n  .bottom-back {\r\n    position: absolute;\r\n    width: 1350px;\r\n    top: -322px;\r\n    left: -138px;\r\n  }\r\n\r\n  .preview {\r\n    padding-top: 80px;\r\n    padding-left: 50px;\r\n  }\r\n\r\n  .only {\r\n    position: absolute;\r\n    width: 163px;\r\n    right: 22px;\r\n    top: 71px;\r\n  }\r\n\r\n  .preview-top {\r\n    position: absolute;\r\n    top: 206px;\r\n    left: 239px;\r\n  }\r\n\r\n  .login-button-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .login-bg {\r\n    height: calc(100vh - 100px);\r\n  }\r\n\r\n  /* ===== Scrollbar CSS ===== */\r\n  /* Firefox */\r\n  * {\r\n    scrollbar-width: auto;\r\n    scrollbar-color: #4b495c #28263d;\r\n  }\r\n\r\n  /* Chrome, Edge, and Safari */\r\n  *::-webkit-scrollbar {\r\n    width: 16px;\r\n  }\r\n\r\n  *::-webkit-scrollbar-track {\r\n    background: #28263d;\r\n  }\r\n\r\n  *::-webkit-scrollbar-thumb {\r\n    background-color: #4b495c;\r\n    border-radius: 2px;\r\n    border: 3px solid #28263d;\r\n  }\r\n\r\n}\r\n\r\n@media (max-width: 1200px) and (min-width: 991px) {\r\n\r\n  .login-panel {\r\n    padding-bottom: 70px;\r\n    padding-top: 70px;\r\n    margin-top: 130px !important;\r\n  }\r\n\r\n  .home-container {\r\n    margin-top: 260px;\r\n  }\r\n\r\n  /* ===== Scrollbar CSS ===== */\r\n  /* Firefox */\r\n  * {\r\n    scrollbar-width: auto;\r\n    scrollbar-color: #4b495c #28263d;\r\n  }\r\n\r\n  /* Chrome, Edge, and Safari */\r\n  *::-webkit-scrollbar {\r\n    width: 16px;\r\n  }\r\n\r\n  *::-webkit-scrollbar-track {\r\n    background: #28263d;\r\n  }\r\n\r\n  *::-webkit-scrollbar-thumb {\r\n    background-color: #4b495c;\r\n    border-radius: 2px;\r\n    border: 3px solid #28263d;\r\n  }\r\n\r\n  .top-back {\r\n    position: absolute;\r\n    width: 1190px !important;\r\n    top: -191px;\r\n    left: -170px;\r\n  }\r\n\r\n  .pl-10 {\r\n    padding-left: 46px;\r\n  }\r\n\r\n  .sub-title {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .title h1 {\r\n    font-size: 35px;\r\n    line-height: 53px;\r\n  }\r\n\r\n  .home-title h1 {\r\n    font-size: 28px;\r\n    font-weight: 500;\r\n    line-height: 25px;\r\n  }\r\n\r\n  .title h2 {\r\n    font-size: 30px;\r\n  }\r\n\r\n  .logo {\r\n\r\n    width: 200px;\r\n\r\n  }\r\n\r\n  .nav-item {\r\n\r\n    padding: 0 10px;\r\n\r\n  }\r\n\r\n\r\n  .custom-tp,\r\n  .custom-btn {\r\n    font-size: 19px;\r\n    padding: 10px 12px;\r\n  }\r\n\r\n\r\n  .info-box-details h3 {\r\n\r\n    font-size: 30px;\r\n  }\r\n\r\n\r\n  .social-btn ul li {\r\n\r\n    margin-bottom: 10px;\r\n\r\n  }\r\n\r\n\r\n  .subscribe input::placeholder {\r\n\r\n\r\n    font-size: 15px;\r\n  }\r\n\r\n\r\n  .submit-ab {\r\n\r\n    width: 35%;\r\n    padding: 14px 10px;\r\n    font-size: 15px;\r\n\r\n  }\r\n\r\n  .footer-menu li {\r\n\r\n    font-size: 12px;\r\n\r\n  }\r\n\r\n  .lg-title {\r\n\r\n    font-size: 40px;\r\n\r\n  }\r\n\r\n  .social-btn img {\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n\r\n  .team {\r\n\r\n    margin-bottom: 50px;\r\n\r\n  }\r\n\r\n  .how-padding {\r\n    padding: 15px !important;\r\n  }\r\n\r\n  .middle-back {\r\n    position: absolute;\r\n    width: 1362px;\r\n    top: -101px;\r\n    right: -576px;\r\n    rotate: 193deg;\r\n  }\r\n\r\n  .bottom-back {\r\n    position: absolute;\r\n    width: 1403px;\r\n    top: 50px;\r\n    left: -138px;\r\n  }\r\n\r\n  .preview {\r\n    padding-top: 85px;\r\n    padding-left: 50px;\r\n  }\r\n\r\n  .info-price-value-img {\r\n    width: 175px;\r\n  }\r\n\r\n  .only {\r\n    position: absolute;\r\n    width: 95px;\r\n    right: 14px;\r\n    top: 82px;\r\n  }\r\n\r\n  .preview-top {\r\n    position: absolute;\r\n    top: 161px;\r\n    left: 121px;\r\n  }\r\n\r\n  .preview-top p {\r\n    font-size: 10px;\r\n    font-family: open-sans;\r\n    display: none;\r\n  }\r\n\r\n  .login-button-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .login-bg {\r\n    height: calc(100vh - 100px);\r\n  }\r\n\r\n}\r\n\r\n\r\n@media (max-width: 1440px) and (min-width: 1200px) {\r\n\r\n  .login-panel {\r\n    padding-bottom: 70px;\r\n    padding-top: 70px;\r\n    margin-top: 130px !important;\r\n  }\r\n\r\n  /* ===== Scrollbar CSS ===== */\r\n  /* Firefox */\r\n  * {\r\n    scrollbar-width: auto;\r\n    scrollbar-color: #4b495c #28263d;\r\n  }\r\n\r\n  /* Chrome, Edge, and Safari */\r\n  *::-webkit-scrollbar {\r\n    width: 16px;\r\n  }\r\n\r\n  *::-webkit-scrollbar-track {\r\n    background: #28263d;\r\n  }\r\n\r\n  *::-webkit-scrollbar-thumb {\r\n    background-color: #4b495c;\r\n    border-radius: 2px;\r\n    border: 3px solid #28263d;\r\n  }\r\n\r\n  .login-button-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .top-back {\r\n    position: absolute;\r\n    width: 1327px;\r\n    top: -204px;\r\n    left: -171px;\r\n  }\r\n\r\n  .social-btn ul li {\r\n\r\n    margin-bottom: 10px;\r\n\r\n  }\r\n\r\n  .how-padding {\r\n    padding: 15px !important;\r\n  }\r\n\r\n  .sub-title {\r\n    font-size: 25px;\r\n  }\r\n\r\n  .title h1 {\r\n    font-size: 45px;\r\n  }\r\n\r\n  .home-title h1 {\r\n    font-size: 31px;\r\n    font-weight: 500;\r\n    line-height: 45px;\r\n  }\r\n\r\n  .title h2 {\r\n    font-size: 35px;\r\n  }\r\n\r\n  .pl-10 {\r\n    padding-left: 46px;\r\n  }\r\n\r\n  .faq-container {\r\n    padding-left: 130px !important;\r\n    padding-right: 130px !important;\r\n  }\r\n\r\n  .middle-back {\r\n    position: absolute;\r\n    width: 1719px !important;\r\n    top: -101px;\r\n    right: -576px;\r\n    rotate: 193deg;\r\n  }\r\n\r\n  .bottom-back {\r\n    position: absolute;\r\n    width: 1717px !important;\r\n    top: -39px;\r\n    left: -138px;\r\n  }\r\n\r\n  .preview {\r\n    padding-top: 100px;\r\n    padding-left: 150px;\r\n  }\r\n\r\n  .info-price-value-img {\r\n    width: 240px;\r\n  }\r\n\r\n  .only {\r\n    position: absolute;\r\n    width: 120px;\r\n    right: 14px;\r\n    top: 79px;\r\n  }\r\n\r\n  .preview-top {\r\n    position: absolute;\r\n    top: 200px;\r\n    left: 118px;\r\n  }\r\n\r\n\r\n  .login-bg {\r\n    height: calc(100vh - 100px);\r\n  }\r\n\r\n  .home-title1 {\r\n    font-size: 30px !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1440px) {\r\n\r\n  /* ===== Scrollbar CSS ===== */\r\n  /* Firefox */\r\n  * {\r\n    scrollbar-width: auto;\r\n    scrollbar-color: #4b495c #28263d;\r\n  }\r\n\r\n  /* Chrome, Edge, and Safari */\r\n  *::-webkit-scrollbar {\r\n    width: 16px;\r\n  }\r\n\r\n  *::-webkit-scrollbar-track {\r\n    background: #28263d;\r\n  }\r\n\r\n  *::-webkit-scrollbar-thumb {\r\n    background-color: #4b495c;\r\n    border-radius: 2px;\r\n    border: 3px solid #28263d;\r\n  }\r\n\r\n  .top-back {\r\n    position: absolute;\r\n    width: 1399px !important;\r\n    top: -242px;\r\n    left: 150px;\r\n  }\r\n\r\n  .pl-10 {\r\n    padding-left: 46px;\r\n  }\r\n\r\n  .how-padding {\r\n    padding: 40px !important;\r\n  }\r\n\r\n  .faq-container {\r\n    padding-left: 220px !important;\r\n    padding-right: 220px !important;\r\n  }\r\n\r\n  .middle-back {\r\n    position: absolute;\r\n    width: 2236px !important;\r\n    top: -101px;\r\n    right: -576px;\r\n    rotate: 193deg;\r\n  }\r\n\r\n  .bottom-back {\r\n    position: absolute;\r\n    width: 1952px !important;\r\n    top: -240px;\r\n    left: 100px;\r\n  }\r\n\r\n  .preview-top {\r\n    position: absolute;\r\n    top: 210px;\r\n    left: 155px;\r\n  }\r\n\r\n  .preview {\r\n    padding-top: 110px;\r\n    padding-left: 150px;\r\n  }\r\n\r\n  .info-price-value-img {\r\n    width: 245px;\r\n  }\r\n\r\n  .login-button-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .login-bg {\r\n    height: calc(100vh - 100px);\r\n  }\r\n\r\n  .home-container {\r\n    margin-top: 200px;\r\n  }\r\n\r\n  .home-title1 {\r\n    font-size: 30px !important;\r\n  }\r\n\r\n  .login-panel {\r\n    padding-bottom: 70px;\r\n    padding-top: 70px;\r\n    margin-top: 130px !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
